import "./CloseButton.scss";
import { useEffect } from "react";
import { useViewerMode } from "../../../contexts/useViewerMode";
import CloseIcon from "../../../assets/icons/close.png";
import ActionButtonStandard from "../Action/ActionButtonStandard";

export default function CloseButton(props) {
   const [viewerMode, ,setViewerMode] = useViewerMode();

   function closeOnEscape(event) {
      // if viewerMode === "select" -> only close modal, not model selector
      const isSelect = viewerMode === "select";
      event.key === "Escape" && props.closeModal();
      isSelect && setViewerMode("select");
   }

   useEffect(() => {
      window.addEventListener("keyup", closeOnEscape);
      return () => {
         window.removeEventListener("keyup", closeOnEscape);
      };
      // eslint-disable-next-line
   }, []);

   return (
      <ActionButtonStandard
         iconImg={CloseIcon}
         handleClick={props.closeModal}
         className="button--close"
      />
   );
}
